module.exports = __webpack_public_path__ + "static/img/1f91c30f1c0ce2edcc62e66ea922206c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_04.png
// module id = Z0Yq
// module chunks = 1